export const customStyles = {
  table: {
    style: {
      border: '3px solid #e9ecf2'
    }
  },
  headRow: {
    style: {
      borderBottomWidth: '4px',
      borderBottomColor: '#e9ecf2'
    }
  },
  rows: {
    border: 'none'
  },
  headCells: {
    style: {
      borderLeftStyle: 'solid',
      borderLeftWidth: '1px',
      borderLeftColor: '#e9ecf2',
      paddingRight: '12px',
      paddingLeft: '12px',

      '&:first-of-type': {
        border: 'none'
      },

      div: {
        '&.rdt_TableCol_Sortable': {
          // width: '100%',
          // display: 'flex',
          // justifyContent: 'center',
          div: {
            marginRight: '3px',
            lineHeight: '15px',
            fontSize: '13px',
            color: '#495057',
            fontWeight: 600
          }
        }
      }
    }
  },
  cells: {
    style: {
      borderRightStyle: 'solid',
      borderRightWidth: '1px',
      borderRightColor: '#e9ecf2',
      paddingLeft: '12px',
      paddingRight: '12px',

      '&:first-of-type': {
        borderRightStyle: 'solid',
        borderRightWidth: '1px',
        borderRightColor: '#e9ecf2',
        borderLeft: 'none'
      },
      '&:last-of-type': {
        border: 'none'
      }
    }
  }
};
